export default "__VITE_ASSET__26OkUW6R__"